import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import HydrationImg from "Images/shop/plp/hsnc001.png";
import ProteinImg from "Images/shop/plp/plpprotein.png";
import PreworkoutImg from "Images/shop/plp/pwt02.png";
const data = {
    protein: {
        img: ProteinImg,
        title: "Protein",
    },
    hydration: {
        img: HydrationImg,
        title: "Hydration",
    },
    preworkout: {
        img: PreworkoutImg,
        title: "Preworkout",
    },
};
const BuildBoxWrapper = ({ product, children, noHeader }) => {
    return (_jsxs("div", { className: "flex flex-col mb-2", style: {
            boxShadow: "2px 2px 9px 0px rgba(0, 0, 0, 0.05)",
        }, children: [!noHeader && product && (_jsxs("div", { className: "flex justify-between items-center bg-bone p-2", children: [_jsxs("span", { className: "font-rhode font-normal uppercase text-xl", children: ["Build your ", data[product].title] }), _jsx("img", { width: 98, height: 98, src: data[product].img, alt: product })] })), _jsx("div", { className: "w-full p-2", children: children })] }));
};
export default BuildBoxWrapper;
